/**
 * @generated SignedSource<<976181b6592a2b97f6bbeb02830c1a04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePipelineParentProjectIdQuery$variables = {
  pipelineLocator: string;
};
export type usePipelineParentProjectIdQuery$data = {
  readonly pipeline: {
    readonly parentProject: {
      readonly id: Branded<string, 'ProjectId'> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type usePipelineParentProjectIdQuery = {
  response: usePipelineParentProjectIdQuery$data;
  variables: usePipelineParentProjectIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pipelineLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "pipelineLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePipelineParentProjectIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "parentProject",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePipelineParentProjectIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "parentProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3691c0831f8db96b0dfbd5898b0faee7",
    "id": null,
    "metadata": {},
    "name": "usePipelineParentProjectIdQuery",
    "operationKind": "query",
    "text": "query usePipelineParentProjectIdQuery(\n  $pipelineLocator: String!\n) {\n  pipeline(pipelineLocator: $pipelineLocator) {\n    parentProject {\n      id\n      _id\n    }\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9119777ccafa0f4f4637606300bcc034";

export default node;
